import Image from 'next/image';
import { motion } from 'framer-motion';

import unifyingImage from './background.svg';
import { LogoStack } from './LogoStack';
import { defaultMotionProps } from './motion';

export const Unifying = () => {
  return (
    <section className="bg-amethyst-08 relative ml:pb-600 pb-350 s:pb-450 m:pb-550">
      <div className="absolute bottom-10 left-0 right-0 object-cover overflow-hidden">
        <Image
          src={unifyingImage}
          alt="Unifying"
          className="w-[1500px] h-full object-cover mx-auto max-w-[180vw] m:max-w-[125vw] m:-translate-x-[12.5vw] -translate-x-[40vw] min-[1300px]:translate-x-0"
        />
      </div>
      <div className="max-w-[1460px] p-main relative mx-auto grid ml:grid-cols-2 gap-30 ml:gap-40 ml:py-150 py-60">
        <motion.div
          className="max-w-[570px] ml:sticky ml:top-100 self-start text-cloud"
          {...defaultMotionProps}
        >
          <h2 className="ml:text-[65px] text-[32px] font-normal leading-[94%] tracking-[-0.65px]">
            Unifying data to
            <span className="text-electric-05"> unlock growth</span>
          </h2>
          <p className="ml:text-[21px] text-[16px] font-light leading-[136%] ml:mt-20 mt-16">
            Our customers connected user data permissioning and orchestration
            across their entire data ecosystem, breaking down silos,
            streamlining operations, and enabling automation at scale.
          </p>
        </motion.div>
        <div className="flex gap-16 ml:gap-24 flex-col">
          <motion.div
            {...defaultMotionProps}
            className={
              'rounded-23 ml:rounded-50 p-20 ml:p-48 text-cloud bg-amethyst-04'
            }
          >
            <h3 className="ml:text-[32px] text-[24px] font-normal leading-[105%] tracking-[-0.32px] text-amethyst-07 text-pretty mb-40">
              Top 10 user data integrations in 2025
            </h3>
            <LogoStack />
          </motion.div>
          <motion.div
            className="rounded-23 ml:rounded-50 p-20 ml:p-48 text-cloud  bg-amethyst-04 flex gap-24 flex-col"
            {...defaultMotionProps}
            transition={{ ...defaultMotionProps.transition, delay: 0.1 }}
          >
            <span className="ml:text-[43px] text-[24px] font-normal leading-[105%] tracking-[-0.79px] trim-text text-amethyst-07">
              Serving users responsibly at a global scale
            </span>
            <span className="block text-14 ml:text-21 font-light leading-[136%] text-pretty">
              Our customers deliver transparent, compliant experiences
              worldwide, supported by 170+ regulations and 189 localization
              options.
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
